export enum STATUS {
	TOO_MANY_REQUESTS = "Can't request more than once",
}
